/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 25/11/2025 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Muestra precio definitivo por medida
*      3       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Usa buscador simple para carga manual de artículos
*      4       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Filtra existencias por clave exacta del artículo seleccionado
*      5       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Mueve acciones y lector a footer flotante
*      6       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Reenfoca y selecciona lector tras acciones
*      7       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Muestra foto del artículo en ficha de verificador
*      8       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Reorganiza ficha visual de artículo y existencias
*      9       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Selección segura de talla y código de barras
*      10      | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Compacta ficha para ampliar tabla de existencias
*      11      | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Muestra código de barras visual para lectura en pantalla
*      12      | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Agrega margen lateral al código de barras visual
*      13      | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Fija ancho físico del código de barras visual
*      14      | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Amplía ancho físico del código de barras visual
*      15      | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Agrega enter al código de barras visual
*      16      | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Retira enter adicional del código de barras visual
*      17      | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Amplía a once centímetros el código de barras visual
*      18      | 08/06/2026 | Lic. José Luis Aragón Cervantes  | Impresión rápida de etiqueta desde verificador
*      19      | 03/07/2026 | Lic. José Luis Aragón Cervantes  | Envía credenciales cargadas de caja al flujo WhatsApp
*      20      | 26/08/2026 | Lic. José Luis Aragón Cervantes  | Recibe artículo desde existencias para consulta de costos
 *      21      | 30/08/2026 | Lic. José Luis Aragón Cervantes  | Botón para enviar artículo a preventas desde verificador
 * ---------------------------------------------------------------------------------------
*/
import React, { Fragment, useEffect, useRef, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormTabLock } from "../../hooks/useFormTabLock";
import { Paper, Typography, FormControlLabel, Checkbox, IconButton, Tooltip, Button } from "@mui/material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { apiBuscarArticuloPorCodigoBarras, apiTomaInventarioZonasArticulo } from '../../settings/ApiConfig';
import { useRequest } from "../../context/System/RequestContext";
import { useSesion } from "../../context/System/SesionContext";
import { useLayout } from "../../context/System/LayoutContext";
import { useVentas } from "../../context/Ventas/VentasContext.js";
import { useInventarios } from '../../context/Inventarios/InventariosContext.js';

import SizeSoftXVentasLayout from "../leyout/SizeSoftXVentasLayout";
import ModalBuscarArticulosSimple from "../herramientas/ModalBuscarArticulosSimple"

import SizeSoftXModal from "../leyout/SizeSoftXModal";
import SizeSoftXAlert from "../utils/SizeSoftXAlert";
import SizeSoftXLoadingProcess from "../leyout/SizeSoftXLoadingProcess";
import SizeSoftXTableExistencias from "../../components/leyout/SizeSoftXTableExistencias"
import MnuVerificadorActions from "../../components/ventas/MnuVerificadorActions.jsx"
import WhatsAppEnvioModal from "../utils/WhatsAppEnvioModal.jsx"


import SizeSoftXLectorCodigoBarrasGeneral from "../leyout/SizeSoftXLectorCodigoBarrasGeneral";

const normalizarImagenArticulo = (imagen) => {
  if (!imagen || typeof imagen !== "string") return null;
  if (imagen.startsWith("data:") || imagen.startsWith("blob:") || imagen.startsWith("http")) return imagen;
  return `data:image/png;base64,${imagen}`;
};

const obtenerImagenArticulo = (articulo, existencias) => {
  const imagen = articulo?.imagen
    || articulo?.foto
    || articulo?.Imagen
    || articulo?.Foto
    || articulo?.IMAGEN
    || articulo?.FOTO
    || existencias?.[0]?.imagen
    || existencias?.[0]?.foto;

  return normalizarImagenArticulo(imagen);
};

const patronesCode128 = [
  "212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213",
  "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132",
  "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211",
  "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313",
  "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331",
  "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111",
  "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214",
  "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111",
  "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141",
  "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141",
  "114131", "311141", "411131", "211412", "211214", "211232", "2331112",
];

const crearBarrasCode128 = (valor) => {
  const texto = (valor || "").toString().trim();
  if (!texto) return null;

  const codigosTexto = Array.from(texto).map((caracter) => caracter.charCodeAt(0) - 32);
  if (codigosTexto.some((codigo) => codigo < 0 || codigo > 94)) return null;

  const startCodeB = 104;
  const checksum = (startCodeB + codigosTexto.reduce((acc, codigo, index) => acc + codigo * (index + 1), 0)) % 103;
  const secuencia = [startCodeB, ...codigosTexto, checksum, 106];
  let posicionX = 0;

  const barras = secuencia.flatMap((codigo) => {
    const patron = patronesCode128[codigo];
    if (!patron) return [];

    return Array.from(patron).flatMap((modulos, index) => {
      const ancho = Number(modulos);
      const barra = index % 2 === 0
        ? [{ x: posicionX, width: ancho }]
        : [];
      posicionX += ancho;
      return barra;
    });
  });

  return { barras, anchoTotal: posicionX, texto };
};

const CodigoBarrasVisual = ({ valor }) => {
  const codigo = crearBarrasCode128(valor);

  if (!codigo) {
    return (
      <div className="verificador-barcode-placeholder">
        Sin código disponible
      </div>
    );
  }

  return (
    <div className="verificador-barcode">
      <svg
        viewBox={`0 0 ${codigo.anchoTotal} 54`}
        preserveAspectRatio="none"
        role="img"
        aria-label={`Código de barras ${codigo.texto}`}
      >
        <rect width={codigo.anchoTotal} height="54" fill="#fff" />
        {codigo.barras.map((barra, index) => (
          <rect
            key={`${barra.x}-${index}`}
            x={barra.x}
            y="0"
            width={barra.width}
            height="54"
            fill="#111827"
          />
        ))}
      </svg>
      <strong>{codigo.texto}</strong>
    </div>
  );
};

export default function FrmVerificador() {
  const location = useLocation();
  const navigate = useNavigate();
  const articuloInicialProcesadoRef = useRef(false);
  const { isLocked: isFormLocked } = useFormTabLock('verificador', {
    title: 'Verificador',
    onLockDetected: (info) => {
      console.warn(`El formulario de ${info?.title || 'Verificador'} ya está abierto en otra pestaña`);
    }
  });

  const panelCodigoBarras = useRef(null);
  const { GetRequest } = useRequest();
  const { handleOpenAlert } = useLayout();
  const { parametrosCajaForm, handleObtenerParametrosCaja } = useSesion();

  const [articulo, setArticulo] = useState(null);
  const [openModalBuscarArticulos, setOpenModalBuscarArticulos] = useState(false);
  const [statusWaiting, setStatusWaiting] = useState(false);
  const [rowExistenciaSeleccionada, setRowExistenciaSeleccionada] = useState(null);
  const [codigoBarrasSeleccionado, setCodigoBarrasSeleccionado] = useState("");
  const [medidaEtiquetaSeleccionada, setMedidaEtiquetaSeleccionada] = useState("");

  const [dataFiltroExistencias, setDataFiltroExistencias] = useState([]);
  const [zonasArticulo, setZonasArticulo] = useState([]);
  const [loadingZonas, setLoadingZonas] = useState(false);
  const [openModalWhatsApp, setOpenModalWhatsApp] = useState(false);
  const { handleObtenerExistenciasAlmacenExhibidor } = useInventarios();
  const { handleClickRegresarMainDashboard, handleRegistrarArticuloSubmitPreVenta } = useVentas();

  const focusSelectLector = useCallback((delay = 60) => {
    setTimeout(() => {
      panelCodigoBarras.current?.focusAndSelect?.();
    }, delay);
  }, []);

  // Estado para checkbox de existencias FULL (persiste en localStorage)
  const [mostrarFull, setMostrarFull] = useState(() => {
    const stored = localStorage.getItem('verificador_mostrar_full');
    return stored === 'true';
  });

  // Guardar preferencia en localStorage cuando cambie
  useEffect(() => {
    localStorage.setItem('verificador_mostrar_full', String(mostrarFull));
  }, [mostrarFull]);

  useEffect(() => {
    if (isFormLocked) {
      alert("El formulario de Verificador ya está abierto en otra pestaña del navegador.\n\nPor favor, cierre la otra ventana o pestaña para continuar.");
      setTimeout(() => {
        handleClickRegresarMainDashboard();
      }, 900);
    }
  }, [isFormLocked]);

  const handleObtenerExistenciasArticulo = async () => {
    if (articulo === undefined || articulo === null) return;

    const almacenExhibidor = mostrarFull ? "FULL" : parametrosCajaForm.dominio;
    const claveArticulo = (articulo.clavearticulo || articulo.sClaveArticulo || "").trim().toUpperCase();
    const filtroExistencias = claveArticulo || articulo.descripcion;
    const listaExistencias = await handleObtenerExistenciasAlmacenExhibidor(filtroExistencias, almacenExhibidor);
    if (!listaExistencias) return;

    const listaArticuloSeleccionado = claveArticulo
      ? listaExistencias.filter((item) =>
        ((item.clavearticulo || item.sClaveArticulo || "").trim().toUpperCase()) === claveArticulo
      )
      : listaExistencias;

    setDataFiltroExistencias(listaArticuloSeleccionado);
    setRowExistenciaSeleccionada(listaArticuloSeleccionado[0] || null);
    setCodigoBarrasSeleccionado(articulo.codigobarras || "");
    setMedidaEtiquetaSeleccionada("");
    focusSelectLector();
  };

  useEffect(() => {
    handleObtenerExistenciasArticulo();
  }, [articulo, mostrarFull]);

  const getRequestRef = useRef(GetRequest);
  getRequestRef.current = GetRequest;

  useEffect(() => {
    if (!articulo?.clavearticulo) return;
    let active = true;
    setLoadingZonas(true);
    (async () => {
      try {
        const url = apiTomaInventarioZonasArticulo.replace(
          "{claveArticulo}", encodeURIComponent(articulo.clavearticulo)
        );
        const response = await getRequestRef.current({ url });
        if (!active) return;
        if (response?.result && Array.isArray(response.result)) {
          setZonasArticulo(response.result);
        } else {
          setZonasArticulo([]);
        }
      } catch {
        if (active) setZonasArticulo([]);
      } finally {
        if (active) setLoadingZonas(false);
      }
    })();
    return () => { active = false; };
  }, [articulo?.clavearticulo]);

  useEffect(() => {
    if (!openModalBuscarArticulos) {
      focusSelectLector(120);
    }
  }, [openModalBuscarArticulos, focusSelectLector]);


  // ---------- cargar parámetros de caja ----------
  useEffect(() => {
    if (
      parametrosCajaForm.caja === "CAJA-DEFAULT" ||
      parametrosCajaForm.caja === null ||
      parametrosCajaForm.caja === undefined
    ) {
      handleObtenerParametrosCaja();
    }
  }, []);

  // ---------- buscar artículo por código de barras (API) ----------
  const handleBuscarArticuloFullData = useCallback(
    async (codigoBarras) => {
      if (!codigoBarras) {
        setArticulo(null);
        return null;
      }

      setStatusWaiting(true);

      const response = await GetRequest({
        url: apiBuscarArticuloPorCodigoBarras.replace("{codigobarras}", codigoBarras),
        alert: "Buscando artículo por código de barras"
      });

      setStatusWaiting(false);

      if (response.hasError) {
        setArticulo(null);
        return null;
      }

      const result = response?.result ?? null;
      if (!result || !result.codigobarras) {
        setArticulo(null);
        return null;
      }
      setArticulo(result);
      return result;
    },
    [GetRequest]
  );

  // ---------- Alt+F1 → abrir buscador manual ----------
  const handleAbrirBuscarManual = () => {
    setOpenModalBuscarArticulos(true);
  };

  const focusFiltroBuscadorArticulos = () => {
    setTimeout(() => {
        const filtroInput = document.querySelector('input[name="Filtro"]');
        if (filtroInput) {
            filtroInput.focus();
            filtroInput.select();
        }
    }, 150);
  };

  const handleKeyDown = useCallback(
    (event) => {
      if (event.altKey && event.key === 'F1') {
        event.preventDefault();
        handleAbrirBuscarManual();
        focusFiltroBuscadorArticulos();
      }
    },
    [handleAbrirBuscarManual]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  // ---------- Handlers básicos ----------
  const handleCerrarBuscarManual = () => {
    setOpenModalBuscarArticulos(false);
    focusSelectLector();
  };

  const handleLimpiarPantalla = () => {
    setArticulo(null);
    setDataFiltroExistencias([]);
    setRowExistenciaSeleccionada(null);
    setCodigoBarrasSeleccionado("");
    setMedidaEtiquetaSeleccionada("");
    focusSelectLector();
  };

  const handleRegistrarArticuloCodigoBarras = async (data) => {
    let codigobarras = "";
    if (!data.codigobarras) { codigobarras = data } else { codigobarras = data.codigobarras }
    await handleBuscarArticuloFullData(codigobarras);
    focusSelectLector();
  };

  const handleArticuloSeleccionadoDesdeBuscador = async (data) => {
    const codigobarras = data?.codigobarras || data?.codigoBarras || data?.listamedidas?.find((m) => m?.codigobarras)?.codigobarras;

    if (codigobarras) {
      await handleBuscarArticuloFullData(codigobarras);
    } else {
      setArticulo(data);
    }

    setOpenModalBuscarArticulos(false);
    focusSelectLector();
  };

  useEffect(() => {
    if (articuloInicialProcesadoRef.current) return;

    const articuloVerificador = location.state?.articuloVerificador;
    if (!articuloVerificador) return;

    articuloInicialProcesadoRef.current = true;
    const codigobarras = articuloVerificador?.codigobarras
      || articuloVerificador?.codigoBarras
      || articuloVerificador?.listamedidas?.find((m) => m?.codigobarras)?.codigobarras;

    if (codigobarras) {
      handleBuscarArticuloFullData(codigobarras);
      return;
    }

    setArticulo(articuloVerificador);
  }, [location.state, handleBuscarArticuloFullData]);

  //Key actions windows
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key.trim().toUpperCase() === 'F4') {
        event.preventDefault();
        handleClickRegresarMainDashboard();
      }

      if (event.altKey && event.key === 'F1') {
        event.preventDefault();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const imagenArticulo = obtenerImagenArticulo(articulo, dataFiltroExistencias);

  const handleSeleccionarRowExistencia = (row) => {
    setRowExistenciaSeleccionada(row);
  };

  const handleSeleccionarMedidaExistencia = (medida) => {
    const row = rowExistenciaSeleccionada || dataFiltroExistencias[0];
    const registro = row?.listamedidas?.find((item) => Number(item.medida) === Number(medida));
    setCodigoBarrasSeleccionado(registro?.codigobarras || articulo?.codigobarras || "");
    setMedidaEtiquetaSeleccionada(medida);
    focusSelectLector();
  };

  const obtenerDatosEtiquetaSeleccionada = () => {
    const codigoActual = (codigoBarrasSeleccionado || articulo?.codigobarras || "").trim();
    const row = rowExistenciaSeleccionada || dataFiltroExistencias[0] || {};
    const medidas = row?.listamedidas || articulo?.listamedidas || [];
    const medidaPorSeleccion = medidas.find((item) => Number(item.medida) === Number(medidaEtiquetaSeleccionada));
    const medidaPorCodigo = medidas.find((item) => (item.codigobarras || "").trim() === codigoActual);
    const medidaFinal = medidaPorSeleccion || medidaPorCodigo;

    return {
      codigoBarras: codigoActual || (medidaFinal?.codigobarras || "").trim(),
      medida: medidaEtiquetaSeleccionada || medidaFinal?.medida || "",
    };
  };

  const handleEnviarAPreventa = async () => {
    if (!articulo) {
      handleOpenAlert("No hay artículo cargado para enviar a preventa", "warning");
      return;
    }

    const { codigoBarras, medida } = obtenerDatosEtiquetaSeleccionada();
    if (!codigoBarras) {
      handleOpenAlert("No se encontró código de barras para enviar a preventa", "warning");
      return;
    }

    const row = rowExistenciaSeleccionada || dataFiltroExistencias[0] || {};
    const medidas = row?.listamedidas || articulo?.listamedidas || [];
    const medidasUnicas = (medidas || []).filter(
      (item, index, arreglo) => arreglo.findIndex((m) => Number(m.medida) === Number(item.medida)) === index
    );

    if (medidasUnicas.length > 1 && !medida) {
      handleOpenAlert("Seleccione la medida del artículo en la lista de medidas y costos", "warning");
      return;
    }

    setStatusWaiting(true);
    try {
      const exito = await handleRegistrarArticuloSubmitPreVenta(
        codigoBarras,
        (parametrosCajaForm?.dominio || "").trim()
      );
      if (!exito) return;

      handleOpenAlert(
        `Artículo enviado a la preventa del folio ${parametrosCajaForm?.foliopreventa || "actual"}`,
        "OK"
      );
      navigate("/preventas");
    } catch (err) {
      handleOpenAlert(err?.message || "Error al enviar a preventa", "error");
    } finally {
      setStatusWaiting(false);
      focusSelectLector();
    }
  };

  const handleImprimirEtiquetaVerificador = async () => {
    if (!articulo) {
      handleOpenAlert("No hay artículo cargado para imprimir etiqueta", "warning");
      return;
    }

    const { codigoBarras, medida } = obtenerDatosEtiquetaSeleccionada();
    if (!codigoBarras) {
      handleOpenAlert("No se encontró código de barras para imprimir etiqueta", "warning");
      return;
    }

    if (!medida) {
      handleOpenAlert("Seleccione una medida antes de imprimir la etiqueta", "warning");
      return;
    }

    let printerName = parametrosCajaForm?.nombreimpresoraetiqueta?.trim() || "";
    if (!printerName) {
      printerName = localStorage.getItem("nombreimpresoraetiqueta") || "";
    }

    if (!printerName) {
      handleOpenAlert("No se encontró la impresora de etiquetas configurada. Configure la impresora en Parámetros de Caja.", "warning");
      return;
    }

    localStorage.setItem("nombreimpresoraetiqueta", printerName);

    const formData = new FormData();
    formData.append("total_etiquetas", 1);
    formData.append("printerName", printerName);
    formData.append("descripcion_articulo", articulo.descripcion || "");
    formData.append("medida", medida);
    formData.append("codigo_barras", codigoBarras);

    setStatusWaiting(true);
    try {
      const response = await fetch("http://localhost:4000/api/imprimiretiquetas", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        const text = await response.text().catch(() => response.statusText);
        handleOpenAlert(`Error en impresión: ${text}`, "error");
        return;
      }

      handleOpenAlert("Etiqueta enviada a impresión", "OK");
    } catch (error) {
      handleOpenAlert(error?.message || "Error al imprimir etiqueta", "error");
    } finally {
      setStatusWaiting(false);
      focusSelectLector();
    }
  };

  return (
    <Fragment>
      <SizeSoftXVentasLayout
        titlePage="Verificador de precios"
        buttonActions={
          <MnuVerificadorActions
            onOpenBuscador={handleAbrirBuscarManual}
            onLimpiarPantalla={handleLimpiarPantalla}
            onWhatsApp={() => setOpenModalWhatsApp(true)}
          />
        }
        detailComponent={null}
      >
        <div className="title-page">
          <p className="columna-1">
            Verificador precios en caja: {parametrosCajaForm.caja}
          </p>
        </div>

        <div className="verificador-container">
          <Paper className="verificador-left" elevation={3} sx={{ p: 2 }}>
            {articulo ? (
              <div className="verificador-articulo-detalles">
                <div className="verificador-articulo-resumen">
                  <div className="verificador-articulo-info">
                    <div className="verificador-articulo-encabezado">
                      <div className="verificador-articulo-clave-col">
                        <strong className="verificador-articulo-clave">{articulo.clavearticulo}</strong>
                        <Button
                          className="verificador-enviar-preventa-btn"
                          variant="contained"
                          color="success"
                          size="small"
                          startIcon={<AddShoppingCartIcon />}
                          disabled={statusWaiting}
                          onClick={handleEnviarAPreventa}
                        >
                          Enviar a preventa
                        </Button>
                      </div>
                      <h1 className="verificador-articulo-descripcion">
                        {articulo.descripcion}
                      </h1>
                    </div>

                    <div className="verificador-articulo-meta">
                      <div>
                        <span>Código de barras</span>
                        <strong>{codigoBarrasSeleccionado || articulo.codigobarras || "Sin código principal"}</strong>
                      </div>
                      <div>
                        <span>Familia / Subfamilia</span>
                        <strong>
                          {articulo.familia}
                          {articulo.subfamilia ? ` / ${articulo.subfamilia}` : ""}
                        </strong>
                      </div>
                      <div className="verificador-articulo-barcode-panel">
                        <span>Lectura en pantalla</span>
                        <div className="verificador-barcode-actions">
                          <CodigoBarrasVisual valor={codigoBarrasSeleccionado || articulo.codigobarras} />
                          <Tooltip title="Imprimir una etiqueta">
                            <IconButton
                              className="verificador-print-label-button"
                              onClick={handleImprimirEtiquetaVerificador}
                              disabled={statusWaiting}
                            >
                              <LocalOfferIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="verificador-consulta-panel">
                  <div className="verificador-consulta-opciones">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={mostrarFull}
                          onChange={(e) => setMostrarFull(e.target.checked)}
                          color="primary"
                        />
                      }
                      label={<strong>Mostrar FULL</strong>}
                    />
                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: mostrarFull ? 'primary.main' : 'text.secondary' }}>
                      Almacén: {mostrarFull ? 'FULL' : parametrosCajaForm.dominio}
                    </Typography>
                  </div>

                  <div className="verificador-consulta-cuerpo">
                    <div className="tablaarticulosfiltrados verificador-tabla-existencias">
                      <div
                        disabled={true}
                      >
                        <SizeSoftXTableExistencias
                          columns={[
                            { title: "Clave artículo", field: "clavearticulo", hideSort: false },
                          ]}
                          data={dataFiltroExistencias == null ? [] : dataFiltroExistencias}
                          id="id"
                          row={rowExistenciaSeleccionada || dataFiltroExistencias[0] || {}}
                          setRow={handleSeleccionarRowExistencia}
                          setClave={() => {}}
                          setMedida={handleSeleccionarMedidaExistencia}
                          fontSize="small"
                          rowsPerPageIntro={50}
                          activaProgress={false}
                          mostrarPrecioDefinitivo={true}
                        //setClave={setClaveArticulo}
                        //setMedida={setMedida}
                        />
                      </div>
                    </div>

                    {imagenArticulo && (
                      <div className="verificador-articulo-foto">
                        <img
                          src={imagenArticulo}
                          alt={articulo.descripcion || "Artículo"}
                        />
                      </div>
                    )}
                  </div>

                  {loadingZonas && (
                    <div style={{ marginTop: '8px', fontSize: '0.75rem', color: '#6b7280' }}>
                      Cargando zonas...
                    </div>
                  )}
                  {!loadingZonas && Array.isArray(zonasArticulo) && zonasArticulo.length > 0 && (
                    <div style={{ marginTop: '8px', padding: '8px 12px', backgroundColor: '#f0fdf4', borderRadius: '8px', border: '1px solid #bbf7d0' }}>
                      <strong style={{ fontSize: '0.8rem', color: '#166534' }}>
                        Zonas en inventario:
                      </strong>
                      <span style={{ marginLeft: '8px', fontSize: '0.8rem', color: '#166534' }}>
                        {zonasArticulo.join(', ')}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="verificador-placeholder">
                <h2>Esperando lectura...</h2>
                <p>
                  Pase un código de barras o presione <strong>Alt+F1</strong> para buscar
                  manualmente.
                </p>
              </div>
            )}
          </Paper>
        </div>

        <div className="footer_verificador">
          <div className="footer_verificador_lector">
            <SizeSoftXLectorCodigoBarrasGeneral
              ref={panelCodigoBarras}
              TipoVenta={"VERIFICADOR"}
              handleRegistrarArticulo={handleRegistrarArticuloCodigoBarras}
              sx={{
                '& h2': {
                  color: '#374151',
                  fontSize: '0.78rem',
                  fontWeight: 600,
                },
                '& input': {
                  width: '100% !important',
                  maxWidth: 'none !important',
                  height: '38px',
                  border: '1px solid rgba(0, 0, 0, 0.23)',
                  borderRadius: '8px',
                  padding: '0 12px',
                  boxSizing: 'border-box',
                  background: '#fff',
                },
              }}
            />
          </div>
        </div>

        <ModalBuscarArticulosSimple
          openModal={openModalBuscarArticulos}
          handleCloseModal={handleCerrarBuscarManual}
          handleArticuloSelect={handleArticuloSeleccionadoDesdeBuscador}
        />

        <SizeSoftXModal />
        <SizeSoftXAlert />
        <SizeSoftXLoadingProcess
          open={statusWaiting}
          message="Consultando información del artículo, por favor espere..."
        />
        <WhatsAppEnvioModal
          openModal={openModalWhatsApp}
          handleCloseModal={() => setOpenModalWhatsApp(false)}
          articulo={articulo}
          almacenexhibidor={parametrosCajaForm.dominio}
          caja={parametrosCajaForm.caja}
          idPhoneWhatsApp={parametrosCajaForm.idphonewhatsapp}
          tokenAccesoWhatsApp={parametrosCajaForm.tokenaccesowhatsapp}
        />
      </SizeSoftXVentasLayout>
    </Fragment>
  );
}
